import React, {useState, useEffect} from 'react';
import {httpPost} from './shared/Config';
import { useTranslation } from 'react-i18next';
import SelectPaymentType from './payments/SelectPaymentType';
import {Icon} from "@iconify/react";

import {Button} from 'reactstrap';
import MoneyFormat from './shared/MoneyFormat';
import ShoppingCartConfirmationModal from '../src/organizations/ShoppingCartConfirmationModal';

const defaultState = {
    paymentType: 'SPEI',
    sub: 'Stripe0',
    type: 'documents'
}

function ShoppingCart({shoppingCartItems, fetchShoppingCart, fetchAccountStatusTrigger, pendingPayments, tenant, companyActive, ivaInclude, currency, blockSpei}) {

    const {t} = useTranslation();

    const [totales, setTotales] = useState({
        speiTotal: 0,
        stripeTotal: 0
    });
    const [total, setTotal] = useState(0);

    const [buyState, setBuyState] = useState({
        paymentType: 'SPEI',
        sub: 'Stripe0',
        type: 'documents'
    });

    const [purchaseModal, setPurchaseModal] = useState({
        open: false
    });

    
    useEffect(() => {
        if(buyState && blockSpei) {
            setBuyState({...buyState, paymentType:"Stripe0"});
        }
    }, [currency, blockSpei]);

    async function handleDeleteShoppingCartItem(item) {
        async function removeFromShoppingCart() {
            const response = await httpPost('/shoppingCart/removeProductFromShoppingCart', {
                id: item.id
            });

            if(response.data.status === "success") {
                // fetch
                fetchShoppingCart();
            }
        }
        removeFromShoppingCart();
    }

    useEffect(() => {
        if(shoppingCartItems) {
            let speiTotal = 0;
            let stripeTotal = 0;
            for(let [k, v] of shoppingCartItems.entries()) {
                speiTotal += v.totalIvaSpei;
                stripeTotal += v.totalIvaStripe;
            }

            setTotales({...totales, speiTotal: speiTotal, stripeTotal:stripeTotal});
            setTotal(speiTotal);
        }
    }, [shoppingCartItems]);

    function handlePaymentTypeChange(type) {
        let discount = 0;
        let paymentTypeCheck = "SPEI";

        switch(type){
            case "SPEI":
                paymentTypeCheck = "SPEI";
                discount = 10;
                setTotal(totales.speiTotal);
                break;
            case "Stripe0":
                paymentTypeCheck = "Stripe0";
                discount = 6;
                setTotal(totales.stripeTotal);
                break;
            default:
                break;
        }

        setBuyState({...buyState, paymentType:paymentTypeCheck});
    }

    function purchaseConfirm() {
        setPurchaseModal({...purchaseModal, isOpen:false})
        fetchShoppingCart();
        fetchAccountStatusTrigger();
    }

    function purchaseCancel() {
        setPurchaseModal({...purchaseModal, isOpen:false})
    }

    function purchaseClick() {
        setPurchaseModal({...purchaseModal, isOpen:true})
    }

    return (
        <React.Fragment>
             {t('SHOPPING_CART')}
            <br/>
            <br/>
            {
                shoppingCartItems ? <React.Fragment>
                    {
                        shoppingCartItems.length <= 0 ? <React.Fragment>
                            <br/>
                            {t('NO_ITEMS')}
                            <br/>  
                            <br/>
                        </React.Fragment> : <React.Fragment>
                            <div>
                                <Button disabled={!companyActive || shoppingCartItems.length <= 0 } style={{marginRight: '5px', width: '100%'}} color="primary" onClick={purchaseClick}>{t('PROCEED_TO_PAYMENT')}</Button>
                            </div>
                        </React.Fragment>
                    }
                    {
                        shoppingCartItems.map((item,i) => (
                            <div key={i}>
                                <div className='flex'>    
                                    <div className='flex items-center flex-1'>
                                        <br/>
                                        {t(item.translateTag)}
                                        <br/>
                                        {t('AMOUNT_OF')}: {item.amount}
                                        <br/>
                                        {
                                            buyState.paymentType === "SPEI" ? <React.Fragment>{t('Amount')}: <MoneyFormat>{item.totalIvaSpei}</MoneyFormat> { currency }</React.Fragment>  : null
                                        }                                
                                        {
                                            buyState.paymentType === "Stripe0" ? <React.Fragment>{t('Amount')}: <MoneyFormat>{item.totalIvaStripe}</MoneyFormat> { currency }</React.Fragment> : null
                                        }
                                        <br/>
                                    </div>
                                    <div className='flex items-center'>
                                        <button className={'btn btn-square'}
                                                    onClick={() => handleDeleteShoppingCartItem(item)}>
                                                <Icon icon="ic:baseline-close" width="24" height="24" />
                                        </button>   
                                    </div> 
                                    <br/>
                                </div>
                                <br/>
                                <hr/>  
                            </div>
                            ))
                    }
                    {
                        shoppingCartItems.length > 0 ? <React.Fragment>
                            <br/>
                            {
                                tenant ? <React.Fragment>
                                    <div>
                                        <SelectPaymentType value={buyState.paymentType} subValue={buyState.sub} action="CONSUMABLE" type="documentos" onChange={handlePaymentTypeChange} pendingPayments={pendingPayments} askFacturacion={false} paymentMethods={tenant.paymentMethods} shoppingCart={true} currency={currency} blockSpei={blockSpei}/>
                                        <br/>
                                    </div>
                                </React.Fragment> : null
                            }
                            <div style={{marginBottom: '10px'}}>Total: <MoneyFormat>{total}</MoneyFormat> { currency }</div>
                        </React.Fragment> : <React.Fragment>
                            <hr/>  
                        </React.Fragment>
                    }
                    <div>
                    <br/>
                    <Button disabled={!companyActive || shoppingCartItems.length <= 0 } style={{marginRight: '5px', width: '100%'}} color="primary" onClick={purchaseClick}>{t('PROCEED_TO_PAYMENT')}</Button>
                    </div>
                    <ShoppingCartConfirmationModal isOpen={purchaseModal.isOpen} onOk={purchaseConfirm} onCancel={purchaseCancel} title="CONFIRM_PURCHASE" paymentType={buyState.paymentType} total={total} ivaInclude={ivaInclude} currency={currency}></ShoppingCartConfirmationModal>
                </React.Fragment> : null
            }
        </React.Fragment>
    );
}
export default ShoppingCart;